<div class="col-sm" *ngIf="route.children.length === 0" >
      <div class="row">
            <div class="col-3">
                  <app-parent-card
                        [parent]="parent"
                        [showSubCount]="false"
                  ></app-parent-card>
            </div>
            <div class="col-9">
                  <div class="row">
                        <div class="col align-middle options-bars">
                              <h1 class="float-start" style="margin: 0px; padding: 0px;">{{viewTitle}}</h1>
                              <div *ngIf="!isPois">
                                    <button 
                                          mat-stroked-button 
                                          color="accent" 
                                          class="button-categories float-end" 
                                          [routerLink]="['./add']"
                                    >
                                          Agregar puntos de interés
                                          <mat-icon>add_circle</mat-icon>
                                    </button> 
                              </div>
                              <div *ngIf="isPois">
                                    <button 
                                          mat-stroked-button 
                                          color="accent" 
                                          class="button-categories float-end" 
                                          [routerLink]="['./add-pois']"
                                    >
                                          Agregar puntos de interés
                                          <mat-icon>add_circle</mat-icon>
                                    </button>
                              </div>
                        </div>
                    </div>
                  <app-categories 
                  [id]="categoryId"
                  [columns]="displayedColumns"
                  [category]="'poi'"
                  ></app-categories>
            </div>
      </div>     
</div>
<router-outlet></router-outlet>
